import { render, staticRenderFns } from "./problem-info.vue?vue&type=template&id=916ee0c2&scoped=true&"
import script from "./problem-info.vue?vue&type=script&lang=js&"
export * from "./problem-info.vue?vue&type=script&lang=js&"
import style0 from "./problem-info.vue?vue&type=style&index=0&id=916ee0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916ee0c2",
  null
  
)

export default component.exports